// A Cakto rompeu o contrato com a Celcoin: nenhuma conta nova pode ser aberta no
// provedor. O backend recusa os endpoints de criação com 403 (switch
// `baas_account_opening_enabled`, fail-closed); isto aqui é só para o seller não
// atravessar o wizard inteiro até tomar o erro.
//
// Fica num módulo próprio porque quem precisa da resposta são dois lados que não
// se importam: o `DigitalAccountOpeningGuard`, que fecha as rotas, e o
// `AccountCreationPanel`, que esconde o picker na aba Banking.
//
// Volta a `true` se a abertura voltar — junto com o switch do backend.
export const ACCOUNT_OPENING_ENABLED = false;
